import type React from 'react'
import type { JSX } from 'react'
import type {
  DESCRIPTION_PADDINGS,
  LAYOUT_BLOCK_PADDINGS,
  NoContentIconSizes,
} from 'vars/index'
import type {
  NoContentBlockAlignItems,
  NoContentBlockDirection,
  NoContentBlockJustifyContent,
} from './NoContentBlock.h'

import { NoContentBlockSC } from './NoContentBlock.styled'

export interface INoContentBlockProps {
  children: React.ReactNode | React.ReactNode[]
  width?: string
  height?: string
  direction?: NoContentBlockDirection
  alignItems?: NoContentBlockAlignItems
  justifyContent?: NoContentBlockJustifyContent
  flexGrow?: number
  paddings?: DESCRIPTION_PADDINGS | LAYOUT_BLOCK_PADDINGS
  className?: string
  style?: React.CSSProperties
  iconSize?: NoContentIconSizes
}

export const NoContentBlock = ({
  children,
  width,
  height,
  direction,
  alignItems,
  justifyContent,
  flexGrow,
  paddings,
  className = '',
  style,
  iconSize,
}: INoContentBlockProps): JSX.Element => (
  <NoContentBlockSC
    blockWidth={width}
    blockHeight={height}
    direction={direction}
    alignItems={alignItems}
    justifyContent={justifyContent}
    flexGrow={flexGrow}
    paddings={paddings}
    className={className}
    style={style}
    iconSize={iconSize}
  >
    {children}
  </NoContentBlockSC>
)
